import { withTransaction } from '@elastic/apm-rum-react'
import { Loader, LogService, MySquid, onConfigChange, onLangChange, SheHulkService } from '@hub/shared'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { SubscriptionLike } from 'rxjs'
import './contract.page.scss'

const ContractPageComponent = ({ configs, ...props }: any) => {
  const { id } = useParams<{ id: string }>()
  let onLangChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  let onConfigChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [contract, setContract] = useState({ contract: '' })
  const [loading, setLoading] = useState(true)
  const [thisConfigs, setConfig] = useState<MySquid>(configs)
  const logService = useMemo(() => new LogService(), [])
  const navigate = useNavigate()
  logService.init('Contract Page')

  const sheHulkService = useMemo(() => new SheHulkService(), [])

  const getContract = useCallback(
    async (language: string, configId = 'hub') => {
      try {
        return await sheHulkService.getPublicContract(id, configId, language)
      } catch (error) {
        logService.error({
          error,
          message: 'Error getting contract',
        })
        return {
          contract: false,
        }
      }
    },
    [id, logService, sheHulkService]
  )

  const getContractFromConfig = useCallback(
    (language: string) => {
      let myContract: any
      getContract(language, thisConfigs?._id)
        .then(({ contract }) => {
          if (!contract && thisConfigs?._id) {
            throw new Error('Contract not found')
          }
          myContract = contract
        })
        .catch(() => {
          if (!myContract && thisConfigs?._id) {
            getContract(language).then(({ contract }) => {
              myContract = contract
            })
          }
        })
        .finally(() => {
          if (!myContract) {
            navigate('/error/not-found')
          }
          setContract({ contract: myContract })
          setLoading(false)
        })
    },
    [getContract, navigate, thisConfigs?._id]
  )

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    onLangChangeSubscription.current = onLangChange.subscribe((language) => {
      setLoading(true)
      // if (id === 'policyprivate' && !thisConfigs?.contract?.hasPrivacyPolicy) {
      //   window.location.href = props?.environments?.externalLinks?.privacyPolicyLW
      //   return
      // }
      getContractFromConfig(language)
    })

    return () => {
      onConfigChangeSubscription?.current?.unsubscribe()
      onLangChangeSubscription?.current?.unsubscribe()
    }
  }, [
    id,
    getContract,
    props?.environments?.externalLinks?.privacyPolicyLW,
    onLangChangeSubscription,
    onConfigChangeSubscription,
    navigate,
    thisConfigs,
    getContractFromConfig,
  ])

  const parseContract = (contract: string) => {
    return (contract = contract?.replace(/<style\b[^<>]*>[\s\S]*?<\/style\s*>/gi, ''))
  }

  if (loading) {
    return <Loader size="big" />
  }

  return (
    <div
      className="content-contract contract-styled"
      style={{ textAlign: 'initial', width: '100%' }}
      dangerouslySetInnerHTML={{ __html: parseContract(contract.contract) }}
    />
  )
}

export default withTransaction('ContractPageComponent', 'component')(ContractPageComponent)
